export default {
  state: {
    user: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    }
  },
  actions: {
    signUserUp ({commit}, newUser) {
      commit('setUser', newUser)
    },
    signUserIn ({commit}, newUser) {
      commit('setUser', newUser)
    },
    autoSignIn ({commit}, payload) {
      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      })
    },
    logout ({commit}) {
      commit('setUser', null)
    }
  },
  getters: {
    user (state) {
      return state.user
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js